import React, { useState, useEffect } from 'react';
import { normalizeGender } from '../config/horseOptions';
import axios from 'axios';
import { API } from '../config/api';
import LoadingSpinner from '../components/LoadingSpinner';

const CompletedAuctionsPage = () => {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuctions = async () => {
      try {
        const response = await axios.get(`${API}/auctions?status=ended`);
        setAuctions(response.data);
      } catch (error) {
        console.error('Error fetching auctions:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAuctions();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <section className="bg-[#0a1628] py-20">
        <div className="container-custom">
          <h1 className="font-display text-5xl text-white">Aste Completate</h1>
          <p className="text-white/70 mt-4">Visualizza le aste concluse e i prezzi di aggiudicazione</p>
        </div>
      </section>

      <section className="section">
        <div className="container-custom">
          {auctions.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-[#64748b] text-lg">Nessuna asta completata</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {auctions.map(auction => (
                <a 
                  key={auction.auction_id} 
                  href={`/asta/${auction.auction_id}`} 
                  className="auction-card block"
                  data-testid={`completed-auction-${auction.auction_id}`}
                >
                  <div className="relative overflow-hidden">
                    {auction.horse?.images?.[0] ? (
                      <img 
                        src={auction.horse.images[0]} 
                        alt={auction.horse?.name}
                        className="card-image w-full h-64 object-cover"
                      />
                    ) : (
                      <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                        <span className="text-gray-400">Nessuna immagine</span>
                      </div>
                    )}
                    <div className="absolute top-4 left-4">
                      <span className="bg-[#64748b] text-white px-3 py-1 text-xs font-bold uppercase tracking-wider">
                        Completata
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="text-[#c9a227] text-sm font-medium uppercase tracking-wider mb-1">
                      {auction.horse?.breed || 'Cavallo'}
                    </p>
                    <h3 className="font-display text-xl mb-2">{auction.title}</h3>
                    {auction.horse && (
                      <p className="text-[#64748b] text-sm mb-4">
                        {normalizeGender(auction.horse.gender)} • {auction.horse.age} anni
                        {auction.horse.color && ` • ${auction.horse.color}`}
                      </p>
                    )}
                    <div className="border-t border-gray-100 pt-4">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="text-xs text-[#64748b] uppercase tracking-wider">Chiusa il</p>
                          <p className="text-sm font-medium">
                            {new Date(auction.end_time).toLocaleDateString('it-IT', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="text-xs text-[#64748b] uppercase tracking-wider">Prezzo finale</p>
                          <p className="text-2xl font-bold text-[#c9a227]">€{auction.current_price?.toLocaleString()}</p>
                        </div>
                      </div>
                      <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center text-sm">
                        <span className="text-[#64748b]">{auction.total_bids} offerte</span>
                        <span className="text-[#c9a227] font-medium">Vedi dettagli →</span>
                      </div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};


export default CompletedAuctionsPage;
